import { COMPANYEMPLOYEE_SHIFT } from "./types";

import moment from "moment";

import ActionHelper from "../helpers/ActionHelper";

export const getCompanyEmployeeShift =
  (companyEmployeeId, shiftId) => (dispatch) => {
    return ActionHelper.requestServer(
      "GET",
      `/companyemployee/${companyEmployeeId}/shift/${shiftId}`,
      null,
      COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_GET_REQUEST,
      COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_GET_SUCCESS,
      COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_GET_FAIL,
      dispatch,
    );
  };

export const updateCompanyEmployeeShift =
  (companyEmployeeId, shiftId, form) => (dispatch) => {
    return ActionHelper.requestServer(
      "PUT",
      `/companyemployee/${companyEmployeeId}/shift/${shiftId}`,
      form,
      COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_UPDATE_REQUEST,
      COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_UPDATE_SUCCESS,
      COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_UPDATE_FAIL,
      dispatch,
    );
  };

export const createReport =
  (companyEmail, employeeEmail, shiftId, state) => (dispatch) => {
    let form = Object.assign({}, state);
    form.signedAt = moment().toISOString();
    form.lines = form.lines.map((l) => ({
      ...l,
      time: l.time ? l.time.format("HH:mm") : l.time,
    }));

    return ActionHelper.requestServer(
      "POST",
      `/company/${companyEmail}/employee/${employeeEmail}/shift/${shiftId}/report`,
      form,
      COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_REQUEST,
      COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_SUCCESS,
      COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_FAIL,
      dispatch,
    );
  };

export const confirmShift = (companyEmployeeId, shiftId) =>
  ActionHelper.requestServer(
    "POST",
    `/companyemployee/${companyEmployeeId}/shift/${shiftId}/confirm`,
  );



// WEBPACK FOOTER //
// ./src/actions/companyEmployeeShiftActions.js